import styled from "styled-components";
import { APadded } from "./layout"
import { Loader, View } from '@aws-amplify/ui-react';


const Central = styled(View)`
    align-items:center;
    justify-content:center;
    flex:1;
    display:flex;
    flex-direction:column;
`

export const Loading = ({message} : { message?: string}) => {
    return  <Central>
            <div>
            <Loader size="large" />
            </div>
            <div>{ message ?? "loading..."}</div>
        </Central>
}